var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(
          _vm.$t("notification.tableViewAdded", {
            actor: _vm.$_.get(_vm.activity, "actorUser.name"),
            tableName: _vm.$_.get(_vm.activity, "payload.tableName"),
            viewName: _vm.$_.get(_vm.activity, "payload.viewName"),
          })
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }